import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    data: {}
}

export const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {
        setHeader: (state, action) => {
            state.data = action.payload
        },
        clearHeader: (state) => {
            state.data = {}
        },

    },
})

export const { setHeader, clearHeader } = headerSlice.actions

export default headerSlice.reducer